
import { Button, Col, Row, Space, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import InputBox from "../../../../components/common/input";
import CommonUpload from "../../../../components/common/upload-image";
import { useDispatch, useSelector } from "react-redux";
import { addCelebrityCategory, updateCelebrityCategory, viewCelebrityCategory } from "../../../../redux/reducer/CelebrityCategorySlice";
import { urlConstant } from "../../../../constants/urlConstant";

import { uploadFile } from "../../../../redux/reducer/UploadSlice";
import FileUploadFun from "../../../../components/common/fileUploadFun/FileUploadFun";
import { toast } from "react-toastify";
import FileUploadTwo from "../../../../components/common/fileUploadFun/FileUploadTwo";

const AddCelebrity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [previewImages, setPreviewImages] = useState(()=>({
    icon: "" 
  }))



  const { addCategoryLoading } = useSelector((prev) => prev?.celebrityCategory);
  const { fileUrl } = useSelector((state) => state.upload);

  // Get edit data from state
  const editData = location.state?.editData || null;
  const [uploadedFile, setUploadedFile] = useState(null);
  const {viewCategory} = useSelector((prev) => prev?.celebrityCategory)

  useEffect(() => {
    if (editData) {
      dispatch(viewCelebrityCategory(editData?.id));
    }
  }, [dispatch, editData]);

 
  const handleFileUpload = async (file) => {
    const data = await dispatch(uploadFile(file));
    setUploadedFile(file);
  };

  // useEffect(() => {
  //   if (fileUrl) {
  //     form.setFieldsValue({ image_url: fileUrl?.rows[0]?.image_url });
  //   }
   
  // }, [fileUrl, form]);

  // Populate form when editing
  useEffect(() => {
    if (viewCategory && editData) {
      form.setFieldsValue({
        name_en: viewCategory.name_en,
        name_es: viewCategory.name_es,
        name_pt: viewCategory.name_pt,
        image_url: viewCategory.image_url,
      });
      setPreviewImages(() => ({
        image_url: viewCategory.image_url
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewCategory.image_url}` 
          : null
      }));
    } else {
      form.resetFields(); // Ensure blank form on add
    }
  }, [editData, viewCategory, form]);

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };

  const onFinish = async (values) => {
    const formData = {
      name_en: values.name_en,
      name_es: values.name_es,
      name_pt: values.name_pt,
      image_url: values.image_url,
    };




  
    try {
      let response;
      if (editData) {
        // Update existing category
        response = await dispatch(updateCelebrityCategory({ id: editData.id, data: formData }));
        if(response.type === "celebrityCategory/update/fulfilled"){
          toast.success("Celebrity updated successfully")
          navigate(-1);
        }   
      } else {
        // Add new category
        response = await dispatch(addCelebrityCategory(formData));
      }
      if (response?.payload?.code === 201 || response?.type === "celebrityCategory/update/fulfilled") {
        toast.success(response?.payload?.message)
        navigate(urlConstant?.manageCelebrityRoute);
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

 

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {editData ? "Edit Celebrity Details" : "Add Celebrity Details"}
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()} loading={addCategoryLoading}>
            {editData ? "Update Details" : "Save Details"}
          </Button>
        </Space>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col xs={24} sm={18}>
            <Row gutter={16}>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="name_en"
                  label="Celebrity Name"
                  rules={[{ required: true, message: "Enter celebrity name" }]}
                >
                  <InputBox size="large" placeholder="Enter celebrity name" className="custom-input" />
                </Form.Item>
              </Col>

              {/* <Col xs={24} sm={8}>
                <Form.Item
                  name="name_es"
                  label="Celebrity Name (ES)"
                  rules={[{ required: true, message: "Enter celebrity name (ES)" }]}
                >
                  <InputBox size="large" placeholder="Enter celebrity name" className="custom-input" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8}>
                <Form.Item
                  name="name_pt"
                  label="Celebrity Name (PT)"
                  rules={[{ required: true, message: "Enter celebrity name (PT)" }]}
                >
                  <InputBox size="large" placeholder="Enter celebrity name" className="custom-input" />
                </Form.Item>
              </Col> */}
            </Row>
          </Col>

          <Col xs={24} sm={6}>
                
            <Form.Item
               name="image_url" label="Upload Image"
                rules={[
                  { required: true, message: "Please upload a banner file" },
                ]}
              >
               <FileUploadTwo
                  label2={"Upload File"}
                  maxFileSizeText={
                    "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                  }
                  setFieldValue={(url) => handleUploadSuccess("image_url", url)}
                  initialPreview={previewImages.image_url}
               />
              {/* <FileUploadFun onFileUpload={handleFileUpload} imagePrev={`${process.env.REACT_APP_IMAGE_URL}/${viewCategory.image_url}`}  /> */}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddCelebrity;


